import { Attribute, Module } from "@apis/index";
import AccessDenied from "@components/access-denied";
import { deletesvg, edit } from "@assets/icons";
import Header from "@commons/header";
import Column from "@components/column";
import DeleteModal from "@components/delete-modal";
import Table from "@components/table";
import { useModal } from "@context/ModalContext";
import { Actions, RootState } from "@store/index";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useQueryState } from "@hooks/useQueryState";

const AttributeTable = ({ moduleId }) => {
  const {
    items: attributes,
    totalItems,
    totalPages,
  } = useSelector((state: RootState) => state.attributes);
  const [page, setPage] = useQueryState<number>("page", 1);
  const [search, setSearch] = useState("");
  const { showModal } = useModal();
  const [error, setError] = useState<string | null>(null);

  const fetchAttributes = async () => {
    setError(null);
    try {
      await Attribute.list({
        state: "attributes",
        params: { page, moduleId, search },
      });
    } catch (err: any) {
      console.error("Failed to fetch attributes:", err);
      setError(err.message || "Failed to load attributes");
    }
  };

  useEffect(() => {
    if (moduleId) fetchAttributes();
  }, [page, moduleId, search]);

  useEffect(() => {
    setPage(1);
  }, [search]);

  const columns = [
    {
      title: "SN",
      key: "sn",
      render: (_item: any, index: number) => index,
    },
    {
      title: "Module",
      key: "module",
      render: (item: any) => item.module?.name || "-",
    },
    {
      title: "Attribute Name",
      key: "name",
      render: (item: any) => item.name.toUpperCase(),
    },
    {
      title: "Values",
      key: "values",
      render: (item: any) => item.values?.join(", ").toUpperCase() || "-",
    },
  ];
  const navigate = useNavigate();

  if (error) {
    return (
      <Column>
        <AccessDenied
          message={error}
          onRetry={fetchAttributes}
        />
      </Column>
    );
  }

  return (
    <Column>
      <Table
        columns={columns}
        data={attributes}
        totalItems={totalItems}
        totalPages={totalPages}
        pageControlled={page}
        onPageChange={setPage}
        itemsPerPage={10}
        hasSearchbar={true}
        onSearchChange={setSearch}
        text="Attributes List"
        actions={[
          {
            key: "edit",
            icon: edit,
            onClick: (item) => {
              navigate(`/admin/product-management/attributes/${item.id}`, {
                state: item,
              });
            },
          },
          {
            key: "delete",
            icon: deletesvg,
            onClick: async (item) => {
              showModal(
                <DeleteModal
                  state="attributes"
                  api={Attribute}
                  id={item.id}
                  onSuccess={() => fetchAttributes()}
                />
              );
            },
          },
        ]}
      />
    </Column>
  );
};

export default AttributeTable;
